import {useEffect, useRef} from 'react';
import {useNavigate} from 'react-router-dom';
import {useAuth0} from '@auth0/auth0-react';

const CallbackPage = () => {
    const navigate = useNavigate();
    const {handleRedirectCallback} = useAuth0();
    const effectRan = useRef(false); // tracks whether the effect has already run to prevent double execution

    useEffect(() => {
        if (!effectRan.current) {
            const processAuthCallback = async () => {
                try {
                    await handleRedirectCallback();
                    navigate('/home');
                } catch {
                    navigate('/auth');
                }
            };
            processAuthCallback();
        }

        return () => {
            effectRan.current = true; // mark effect as completed to prevent rerun 
        };
    }, [handleRedirectCallback, navigate]);

    return null; // only handles redirects, no UI
};

export default CallbackPage;
